'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:position:getCity');
}

var _invoke = require('../invoke');

/**
 * 获取当前选择的城市
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof position
 * @static
 * @name getCity
 * @return {Promise<city>}
 * @example
 *  hbnb.position.getCity()
 *      .then(function(city) {
 *          city = {
 *              cityId: 1,
 *              cityName: '北京'
 *              cityPinyin: 'beijing'
 *          }
 *      });
 */
module.exports = function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('call get city');
    }
    var p = new Promise(function(resolve, reject) {
        _invoke('position', 'get_city', {
            callback: function(city) {
                if (process.env.NODE_ENV !== 'production') {
                    debug('return city %j', city);
                }
                resolve(city);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/position/get-city.js
// module id = 252
// module chunks = 4